import React from "react";

const PauseIcon = ({ fillColor }: { fillColor: string }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.00 10C11.63 10 11.33 10.29 11.33 10.66V21.33C11.33 21.70 11.63 22 12.00 22H14.66C15.03 22 15.33 21.70 15.33 21.33V10.66C15.33 10.29 15.03 10 14.66 10H12.00Z"
      fill={fillColor}
    />
    <path
      d="M17.33 10C16.96 10 16.66 10.29 16.66 10.66V21.33C16.66 21.70 16.96 22 17.33 22H20.00C20.36 22 20.66 21.70 20.66 21.33V10.66C20.66 10.29 20.36 10 20.00 10H17.33Z"
      fill={fillColor}
    />
  </svg>
);

export default PauseIcon;
